const arRuntimeTranslations: Record<string, string> = {
  'Dashboard': 'لوحة التحكم',
  'Club': 'النادي',
  'Leaderboard': 'الترتيب',
  'Members': 'الأعضاء',
  'Queue & Courts': 'الانتظار والملاعب',
  'Evaluations': 'التقييمات',
  'Equipment': 'المعدات',
  'Match History': 'سجل المباريات',
  'Daily Match Report': 'تقرير المباريات اليومي',
  'Profile': 'الملف الشخصي',
  'Theme & App': 'الثيم والتطبيق',
  'Settings': 'الإعدادات',
  'Packages': 'الباقات',
  'Rank': 'الترتيب',
  'Player': 'اللاعب',
  'Rating': 'التقييم',
  'Games': 'المباريات',
  'Points': 'النقاط',
  'Point Difference (PD)': 'فارق النقاط (PD)',
  'Won': 'فاز',
  'Lost': 'خسر',
  'Scored': 'سجل',
  'Against': 'ضد',
  'Showing': 'عرض',
  'total': 'الإجمالي',
  'Page': 'الصفحة',
  'Prev': 'السابق',
  'Next': 'التالي',
  'Manage your club members': 'إدارة أعضاء النادي',
  'Manage your club members (': 'إدارة أعضاء النادي (',
  'Import Members CSV': 'استيراد أعضاء من CSV',
  'Upload CSV with headers: firstname, lastname, email.': 'ارفع ملف CSV بهذه الأعمدة: الاسم الأول، اسم العائلة، البريد الإلكتروني.',
  'Upload CSV with headers:': 'ارفع ملف CSV بهذه الأعمدة:',
  'Role': 'الدور',
  'CSV File': 'ملف CSV',
  'Choose CSV': 'اختر CSV',
  'No file selected': 'لم يتم اختيار ملف',
  'Remaining member slots:': 'المقاعد المتبقية للأعضاء:',
  'Selected:': 'المحدد:',
  'CSV rows:': 'صفوف CSV:',
  'First Name': 'الاسم الأول',
  'Last Name': 'اسم العائلة',
  'Available': 'متاح',
  'Select': 'تحديد',
  'Name': 'الاسم',
  'Email': 'البريد الإلكتروني',
  'Upload a CSV to preview members.': 'ارفع ملف CSV لمعاينة الأعضاء.',
  'Reset': 'إعادة تعيين',
  'Import Selected': 'استيراد المحدد',
  'Choose Your Avatar': 'اختر صورتك الشخصية',
  'Selected': 'محدد',
  'None': 'لا يوجد',
  'Notes': 'ملاحظات',
  'No players in queue': 'لا يوجد لاعبون في قائمة الانتظار',
  'No players match your search.': 'لا يوجد لاعب يطابق البحث.',
  'No prior head to head': 'لا يوجد سجل مواجهات سابق',
  'Shuffle': 'خلط',
  'Clear': 'مسح',
  'Admin': 'مدير',
  'Candidate': 'مرشح',
  'time in queue': 'الوقت في قائمة الانتظار',
  'Time Elapsed:': 'الوقت المنقضي:',
  'Assigned by:': 'تم الإسناد بواسطة:',
  'Selection Criteria:': 'معيار الاختيار:',
  'Selection Criteria: Not set': 'معيار الاختيار: غير محدد',
  'Finish Match': 'إنهاء المباراة',
  'Finish Match - Court': 'إنهاء المباراة - الملعب',
  'Finish': 'إنهاء',
  'Enter the final score and any match notes.': 'أدخل النتيجة النهائية وأي ملاحظات على المباراة.',
  'Team 1': 'الفريق 1',
  'Team 2': 'الفريق 2',
  'Final score cannot be a tie.': 'لا يمكن أن تكون النتيجة النهائية تعادلاً.',
  'Equipment Used (Optional)': 'المعدات المستخدمة (اختياري)',
  'You can optionally record which equipment was used in this match': 'يمكنك اختياريًا تسجيل المعدات المستخدمة في هذه المباراة',
  'Shoes': 'الأحذية',
  'Select shoes...': 'اختر الأحذية...',
  'Racket': 'المضرب',
  'Select racket...': 'اختر المضرب...',
  'Notes (Optional)': 'ملاحظات (اختياري)',
  'Any notes about the match...': 'أي ملاحظات حول المباراة...',
  'Evaluate players and admins': 'تقييم اللاعبين والمديرين',
  'All ratings': 'كل التقييمات',
  'Filter rating': 'تصفية التقييم',
  'Not evaluated': 'غير مقيّم',
  '4 stars': '4 نجوم',
  '3 stars': '3 نجوم',
  'Rate each category and add a quarter plan for this player.': 'قيّم كل فئة وأضف خطة ربع سنوية لهذا اللاعب.',
  'New Evaluation': 'تقييم جديد',
  'Edit Evaluation': 'تعديل التقييم',
  'Category Ratings (1-5)': 'تقييمات الفئات (1-5)',
  'Quarter Plan': 'خطة الربع',
  'Plan to improve over the next quarter...': 'خطة للتحسن خلال الربع القادم...',
  'Submit Evaluation': 'إرسال التقييم',
  'Cancel': 'إلغاء',
  'Delete': 'حذف',
  'Collapse': 'طي',
  'Last 3': 'آخر 3',
  'Last 10': 'آخر 10',
  'View all': 'عرض الكل',
  'My Equipment': 'معداتي',
  'Manage your badminton gear': 'إدارة معدات كرة الريشة الخاصة بك',
  'Add Equipment': 'إضافة معدات',
  'No shoes added yet': 'لم تتم إضافة أحذية بعد',
  'No rackets added yet': 'لم تتم إضافة مضارب بعد',
  'Type': 'النوع',
  'Manufacturer *': 'الشركة المصنعة *',
  'Other': 'أخرى',
  'Enter manufacturer': 'أدخل الشركة المصنعة',
  'Make/Model *': 'العلامة/الطراز *',
  'View all completed matches': 'عرض جميع المباريات المكتملة',
  'All dates': 'كل التواريخ',
  'Finished': 'مكتملة',
  'Assigned by': 'تم الإسناد بواسطة',
  'Finished by': 'أنهاها',
  'Winner': 'الفائز',
  'Started': 'بدأت',
  'Debuted': 'بدأت',
  'Endished': 'مكتملة',
  'Only matches that started and finished on the selected date.': 'فقط المباريات التي بدأت وانتهت في التاريخ المحدد.',
  'Total Matches': 'إجمالي المباريات',
  'Players Played': 'اللاعبون المشاركون',
  'Avg Matches / Player': 'متوسط المباريات / لاعب',
  'Matches by Selection': 'المباريات حسب الاختيار',
  'No matches': 'لا توجد مباريات',
  'Player Summary': 'ملخص اللاعب',
  'Unique opponents can be higher than total matches (each match has two opponents).': 'قد يكون عدد الخصوم الفريدين أكبر من إجمالي المباريات (لكل مباراة خصمان).',
  'Unique Opponents': 'الخصوم الفريدون',
  'Unique Partners': 'الشركاء الفريدون',
  'No matches played on this date.': 'لم تُلعب أي مباريات في هذا التاريخ.',
  'Opponents Matrix': 'مصفوفة الخصوم',
  'ALL': 'الكل',
  'Hide': 'إخفاء',
  'No matches to show.': 'لا توجد مباريات للعرض.',
  'My Profile': 'ملفي الشخصي',
  'View and edit your profile information': 'عرض وتعديل معلومات ملفك الشخصي',
  'Not rated': 'غير مقيّم',
  'Awaiting coach evaluation': 'بانتظار تقييم المدرب',
  'Profile Avatar': 'الصورة الشخصية',
  'Avatar feature is available on Elite (Package 3)': 'ميزة الصورة الشخصية متاحة في إيليت (الباقة 3)',
  'Upgrade to Package 3 to use and manage profile avatars.': 'قم بالترقية إلى الباقة 3 لاستخدام وإدارة الصور الشخصية.',
  'Personal Information': 'المعلومات الشخصية',
  'Policy Consent': 'الموافقة على السياسات',
  'I agree to the Privacy Policy.': 'أوافق على سياسة الخصوصية.',
  'I agree to the Terms and Conditions.': 'أوافق على الشروط والأحكام.',
  'I agree to the': 'أوافق على',
  'Terms and Conditions': 'الشروط والأحكام',
  'Privacy Policy': 'سياسة الخصوصية',
  'No evaluations yet': 'لا توجد تقييمات بعد',
  'Choose an avatar to represent you in the club. This will be visible to coaches and other members.': 'اختر صورة شخصية تمثلك في النادي. ستكون مرئية للمدربين والأعضاء الآخرين.',
  'Edit': 'تعديل',
  'Search members': 'ابحث عن الأعضاء',
  'Search members...': 'ابحث عن الأعضاء...',
  'Search Members...': 'ابحث عن الأعضاء...',
  'All roles': 'كل الأدوار',
  'Add New Member': 'إضافة عضو جديد',
  'Edit Member': 'تعديل العضو',
  'Cancel Edit': 'إلغاء التعديل',
  'Create Club': 'إنشاء نادي',
  'Create your club to get started': 'أنشئ ناديك للبدء',
  'Search by player name': 'ابحث باسم اللاعب',
  'Add a new member to your club. They will receive a first-time login link.': 'أضف عضوًا جديدًا إلى ناديك. سيتلقى رابط تسجيل دخول أول مرة.',
  'Club Information': 'معلومات النادي',
  'View your club details': 'عرض تفاصيل ناديك',
  'Rackets': 'المضارب',
  'Security': 'الأمان',
  'Enable 2FA for login (email OTP will be required every time).': 'تفعيل المصادقة الثنائية لتسجيل الدخول (سيُطلب OTP عبر البريد الإلكتروني في كل مرة).',
  'Save': 'حفظ',
  'Manage application settings': 'إدارة إعدادات التطبيق',
  'This feature is available on Elite (Package 3) only.': 'هذه الميزة متاحة فقط في إيليت (الباقة 3).',
  'This feature is available on Elite (الباقة 3) only.': 'هذه الميزة متاحة فقط في إيليت (الباقة 3).',
  'Welcome back,': 'مرحبًا بعودتك،',
  "Here's what's happening at your club.": 'إليك ما يحدث في ناديك.',
  'AI Coaching Insights': 'رؤى التدريب بالذكاء الاصطناعي',
  'your ai insights timeline': 'الخط الزمني لرؤى الذكاء الاصطناعي الخاصة بك',
  'Explore multiple AI-powered insights each week for a complete performance perspective.': 'استكشف عدة رؤى مدعومة بالذكاء الاصطناعي كل أسبوع للحصول على صورة أداء متكاملة.',
  'Elite Plan': 'خطة إيليت',
  'Generate weekly insight': 'إنشاء رؤية أسبوعية',
  'Weekly Insights': 'الرؤى الأسبوعية',
  'No previous week insights yet.': 'لا توجد رؤى للأسابيع السابقة بعد.',
  'insights in this week': 'رؤى هذا الأسبوع',
  'No previous week insights yet.': 'لا توجد رؤى للأسابيع السابقة بعد.',
  'Win Rate': 'نسبة الفوز',
  'Matches': 'المباريات',
  'Court Time': 'وقت الملعب',
  'Coaching Takeaways': 'خلاصات التدريب',
  'Visible': 'مرئي',
  'Total Members': 'إجمالي الأعضاء',
  'Active Matches': 'المباريات النشطة',
  'No active matches right now.': 'لا توجد مباريات نشطة الآن.',
  'Club Statistics': 'إحصائيات النادي',
  'Matches Played Today': 'المباريات التي لُعبت اليوم',
  'Played Today': 'لُعب اليوم',
  'Matches In Progress': 'المباريات الجارية',
  'Avg Active Courts / Day': 'متوسط الملاعب النشطة / يوم',
  'Club Matches': 'مباريات النادي',
  'Completed matches in selected club': 'المباريات المكتملة في النادي المحدد',
  'Avg Matches per Court / Day': 'متوسط المباريات لكل ملعب / يوم',
  'Avg Queue Wait (min)': 'متوسط انتظار القائمة (دقيقة)',
  'Avg Match Duration': 'متوسط مدة المباراة',
  'Personalized Statistics for': 'إحصائيات مخصصة لـ',
  'Total Matches Played Till-Date': 'إجمالي المباريات حتى الآن',
  'Matches Today': 'مباريات اليوم',
  'Matches Won Today': 'المباريات التي فاز بها اليوم',
  'Max Matches Won on a Day': 'أقصى مباريات فاز بها في يوم',
  'Max Matches Lost on a Day': 'أقصى مباريات خسرها في يوم',
  'Points Scored per Match': 'النقاط المسجلة لكل مباراة',
  'Net Points per Match': 'صافي النقاط لكل مباراة',
  'Wins & Losses by Day': 'الفوز والخسارة حسب اليوم',
  'Points Scored vs Points Lost by Day': 'النقاط المسجلة مقابل المستقبلة حسب اليوم',
  'Evaluation Progress Over Time': 'تطور التقييم عبر الوقت',
  'Waiting for evaluations.': 'بانتظار التقييمات.',
  'Leaderboard Rank (Last 30 Days)': 'ترتيبك في التصنيف (آخر 30 يومًا)',
  'Club Matches by Selection Mode (Last 30 Days)': 'مباريات النادي حسب وضع الاختيار (آخر 30 يومًا)',
  'My Evaluation Profile': 'ملف تقييمي',
  'Evaluation data is not available yet.': 'بيانات التقييم غير متوفرة بعد.',
  'Queue Wait Time Distribution': 'توزيع وقت انتظار القائمة',
  'Court Usage by Day of Week': 'استخدام الملاعب حسب يوم الأسبوع',
  'Court': 'الملعب',
  'Visual unavailable': 'العرض المرئي غير متاح',
  'Available in Pro and Elite': 'متاح في برو وإيليت',
  'Club Settings': 'إعدادات النادي',
  'Edit your club details and settings': 'تعديل تفاصيل ناديك وإعداداته',
  'Basic Information': 'المعلومات الأساسية',
  "Your club's identity": 'هوية ناديك',
  'Club Logo': 'شعار النادي',
  'Click to upload an image': 'اضغط لرفع صورة',
  'Club Name *': 'اسم النادي *',
  'Which sport does your club play? *': 'ما الرياضة التي يمارسها ناديك؟ *',
  'Select sport': 'اختر الرياضة',
  'Slogan': 'الشعار',
  'Address': 'العنوان',
  'Play Schedule': 'جدول اللعب',
  'Configure your weekly play schedule': 'قم بإعداد جدول اللعب الأسبوعي',
  'Play Days': 'أيام اللعب',
  'Default Play Time': 'وقت اللعب الافتراضي',
  'Scheduled Play Times': 'أوقات اللعب المجدولة',
  'Day': 'اليوم',
  'Start': 'البداية',
  'End': 'النهاية',
  'Add': 'إضافة',
  'Capacity Settings': 'إعدادات السعة',
  'Approximate Players': 'عدد اللاعبين التقريبي',
  'Number of Courts': 'عدد الملاعب',
  'Player Selection Mode': 'وضع اختيار اللاعبين',
  'How players are assigned to courts': 'كيف يتم توزيع اللاعبين على الملاعب',
  'Queue & Court Controls': 'عناصر التحكم في القائمة والملاعب',
  'Enable or disable drag swap and queue shuffle': 'تفعيل أو تعطيل تبديل السحب وخلط قائمة الانتظار',
  'Enabled': 'مفعل',
  'Disabled': 'معطل',
  'Billing & Subscription': 'الفوترة والاشتراك',
  'Current status': 'الحالة الحالية',
  'Current plan': 'الباقة الحالية',
  'Trial ends': 'تنتهي التجربة',
  'Start / Update Checkout': 'بدء / تحديث الدفع',
  'Manage Billing': 'إدارة الفوترة',
  'Cancel Subscription': 'إلغاء الاشتراك',
  'Recent invoices': 'الفواتير الأخيرة',
  'Save Changes': 'حفظ التغييرات',
  'Package': 'الباقة',
  'Member': 'عضو',
  'Players': 'اللاعبون',
  'member': 'عضو',
  'search member...': 'ابحث عن عضو...',
  'Filters': 'الفلاتر',
  'filters': 'الفلاتر',
  'Member Evaluations': 'تقييمات الأعضاء',
  'Evaluate': 'تقييم',
  '1 star': 'نجمة واحدة',
  '2 stars': 'نجمتان',
  'No players to evaluate. Add players first!': 'لا يوجد لاعبون لتقييمهم. أضف اللاعبين أولاً!',
  'new evaluation': 'تقييم جديد',
  'Add new evaluation': 'إضافة تقييم جديد',
  'Existing Evaluations': 'التقييمات الحالية',
  'Queue': 'قائمة الانتظار',
  'Assign Players': 'تعيين اللاعبين',
  'Assigning': 'جارٍ التعيين',
  'Players Pick Mode': 'وضع اختيار اللاعبين',
  'All players selected. Assigning shortly...': 'تم تحديد جميع اللاعبين. سيتم التعيين بعد قليل...',
  'Queue': 'قائمة الانتظار',
  'Add to Queue': 'إضافة إلى قائمة الانتظار',
  'Avatar Selection': 'اختيار الصورة الشخصية',
  '3 insights in this week': '3 رؤى هذا الأسبوع',
  'Stripe': 'سترايب',
  'Completed matches divided by courts across active match days': 'المباريات المكتملة مقسومة على عدد الملاعب خلال أيام النشاط',
  'From club queue sessions': 'من جلسات قائمة انتظار النادي',
  'Average duration of completed club matches': 'متوسط مدة المباريات المكتملة في النادي',
  'Logo is locked until you edit the club': 'الشعار مقفل حتى تقوم بتعديل بيانات النادي',
  'Monday': 'الاثنين',
  'Tuesday': 'الثلاثاء',
  'Wednesday': 'الأربعاء',
  'Thursday': 'الخميس',
  'Friday': 'الجمعة',
  'Saturday': 'السبت',
  'Sunday': 'الأحد',
  'Round Robin': 'التدوير المتوازن',
  'Randomly picks 4 of the top 6, balances them into teams, and guarantees the remaining 2 are chosen next.': 'يختار عشوائيًا 4 من أول 6 لاعبين، ويوازنهم في فرق، ويضمن اختيار اللاعبين المتبقين في الدور التالي.',
  'Skill Based': 'حسب المستوى',
  'Selects the top‑queued player, then picks others with the same skill (or closest skill if none), prioritizing higher wait time when multiple matches exist.': 'يختار أول لاعب في قائمة الانتظار، ثم يضم لاعبين بالمستوى نفسه أو الأقرب له، مع إعطاء أولوية لمن انتظروا أكثر عند وجود عدة مباريات.',
  'Balanced Teams': 'فرق متوازنة',
  'Takes the top two in queue, then matches skill to balance teams; if multiple combos fit, prioritizes longer wait time.': 'يأخذ أول لاعبين في قائمة الانتظار ثم يوزع الباقين حسب المستوى لتحقيق توازن الفرق، ومع تعدد الخيارات يعطي أولوية لمن انتظروا مدة أطول.',
  'Players Pick': 'اختيار اللاعبين',
  'Top queue player picks 3 teammates for the earliest free court; admin/coach can assist.': 'يختار أول لاعب في قائمة الانتظار 3 زملاء له لأول ملعب متاح، ويمكن للمدير أو المدرب المساعدة.',
  'Allow Swap of players once assigned to a court': 'السماح بتبديل اللاعبين بعد تعيينهم في ملعب',
  'Allow suffle of the queue (Please Note it will reset wait time in queue and shuffle players position in queue)': 'السماح بخلط قائمة الانتظار (يرجى الملاحظة أن ذلك سيعيد ضبط وقت الانتظار ويغيّر ترتيب اللاعبين في القائمة)',
  'Allow suffle of the queue (Please التقييم it will reset wait الوقت في قائمة الانتظار and shuffle players position in queue)': 'السماح بخلط قائمة الانتظار (يرجى الملاحظة أن ذلك سيعيد ضبط وقت الانتظار ويغيّر ترتيب اللاعبين في القائمة)',
  'Manage your Stripe subscription, invoices, and payment method securely.': 'إدارة اشتراك سترايب والفواتير ووسيلة الدفع الخاصة بك بشكل آمن.',
  'Upgrade your plan': 'قم بترقية باقتك',
  'Unlock': 'افتح',
  "This feature isn't available in your current plan.": 'هذه الميزة غير متاحة في باقتك الحالية.',
  'Your Current Plan': 'باقتك الحالية',
  'Current Plan': 'الباقة الحالية',
  'Upgrade Package': 'ترقية الباقة',
  'View Package Details': 'عرض تفاصيل الباقات',
  'Available on Pro': 'متاحة في برو',
  'and Elite': 'وإيليت',
  'Available on Pro (Package 2) and Elite (Package 3).': 'متاحة في برو (الباقة 2) وإيليت (الباقة 3).',
  'Please contact your club admin to upgrade the package and unlock this feature.': 'يرجى التواصل مع مدير النادي لترقية الباقة وفتح هذه الميزة.',
  'Please contact your club admin to unlock evaluations.': 'يرجى التواصل مع مدير النادي لفتح التقييمات.',
  'Please contact your club admin to unlock this insight.': 'يرجى التواصل مع مدير النادي لفتح هذه الرؤية.',
  'Coach role is available on Pro (Package 2) and Elite (Package 3).': 'دور المدرب متاح في برو (الباقة 2) وإيليت (الباقة 3).',
  'Enabled (Email OTP required on login)': 'مفعل (مطلوب OTP عبر البريد الإلكتروني عند تسجيل الدخول)',
  'Disabled': 'معطل',
  'Time in Queue:': 'الوقت في قائمة الانتظار:',
  'Remove from queue?': 'إزالة من قائمة الانتظار؟',
  'You are about to remove': 'أنت على وشك إزالة',
  'from the queue. Are you sure?': 'من قائمة الانتظار. هل أنت متأكد؟',
  'Remove from court?': 'إزالة من الملعب؟',
  'from the court. They will be placed at the end of the queue. Continue?': 'من الملعب. سيتم وضعه في نهاية قائمة الانتظار. هل تريد المتابعة؟',
  'Remove': 'إزالة',
  'Removing...': 'جارٍ الإزالة...',
  'Finishing...': 'جارٍ الإنهاء...',
  'This will randomize the current queue order. Are you sure you want to shuffle the queue?': 'سيؤدي هذا إلى خلط ترتيب قائمة الانتظار الحالية. هل أنت متأكد أنك تريد خلط قائمة الانتظار؟',
  'This will remove all queued players. Are you sure you want to reset the queue?': 'سيؤدي هذا إلى إزالة جميع اللاعبين الموجودين في قائمة الانتظار. هل أنت متأكد أنك تريد إعادة تعيين القائمة؟',
  'Yes, continue': 'نعم، متابعة',
  'Avg time in queue': 'متوسط الوقت في قائمة الانتظار',
  'Unlock weekly AI insights': 'افتح الرؤى الأسبوعية بالذكاء الاصطناعي',
  'Upgrade your plan to unlock complete AI-driven performance insights.': 'قم بترقية باقتك لفتح رؤى أداء كاملة مدعومة بالذكاء الاصطناعي.',
  'Upgrade your plan to see full insight': 'قم بترقية باقتك لعرض الرؤية الكاملة',
  'unlock weekly ai insights': 'افتح الرؤى الأسبوعية بالذكاء الاصطناعي',
  'Starter Plan': 'خطة ستارتر',
  'Upgrade to unlock': 'قم بالترقية للفتح',
  'First AI Insight': 'أول رؤية بالذكاء الاصطناعي',
  'View your category-wise skill profile and identify strengths and improvement areas.': 'اعرض ملف مهاراتك حسب الفئات وحدد نقاط القوة ومجالات التحسين.',
  'Generate your first weekly coaching summary.': 'أنشئ أول ملخص تدريبي أسبوعي لك.',
  'your weekly ai insight': 'رؤيتك الأسبوعية بالذكاء الاصطناعي',
  'Get a concise weekly AI insight designed to highlight your key performance trends.': 'احصل على رؤية أسبوعية موجزة بالذكاء الاصطناعي تبرز أهم اتجاهات أدائك.',
  'Your insight will use real match stats, court activity, ranking movement, evaluations, and equipment usage to produce a short coaching takeaway.': 'ستستخدم رؤيتك إحصاءات المباريات الحقيقية ونشاط الملاعب وحركة الترتيب والتقييمات واستخدام المعدات لإنتاج خلاصة تدريبية قصيرة.',
  'Generate My Weekly Insight': 'أنشئ رؤيتي الأسبوعية',
  'Upgrade to view insights': 'قم بالترقية لعرض الرؤى',
  'Club logo is an Elite feature': 'شعار النادي ميزة متاحة في إيليت',
  'Upgrade to Package 3 (Elite) to upload and manage your club logo.': 'قم بالترقية إلى الباقة 3 (إيليت) لرفع شعار النادي وإدارته.',
  'evaluations are unavailable on Starter (Package 1)': 'التقييمات غير متاحة في ستارتر (الباقة 1)',
  'التقييمات are unavailable on Starter (الباقة 1)': 'التقييمات غير متاحة في ستارتر (الباقة 1)',
  'Upgrade to Pro or Elite to view evaluation history and category scores.': 'قم بالترقية إلى برو أو إيليت لعرض سجل التقييمات ودرجات الفئات.',
  'You can change the package from club settings': 'يمكنك تغيير الباقة من إعدادات النادي',
  'You can change the package from النادي settings': 'يمكنك تغيير الباقة من إعدادات النادي',
  'Two-factor authentication is enabled for this account.': 'تم تفعيل المصادقة الثنائية لهذا الحساب.',
  'Enter the OTP sent to': 'أدخل رمز OTP المرسل إلى',
  'OTP Code': 'رمز OTP',
  'Change Email': 'تغيير البريد الإلكتروني',
  'Choose your package': 'اختر باقتك',
  'All packages (monthly and yearly) include a 14-day free trial.': 'جميع الباقات الشهرية والسنوية تشمل تجربة مجانية لمدة 14 يومًا.',
  'Cancel anytime before the 14-day trial ends to avoid charges.': 'يمكنك الإلغاء في أي وقت قبل انتهاء التجربة لمدة 14 يومًا لتجنب الرسوم.',
  'Starter Package': 'باقة ستارتر',
  'Up to 50 active members': 'حتى 50 عضوًا نشطًا',
  'Member management': 'إدارة الأعضاء',
  'Queue and court assignment': 'إدارة الانتظار وتوزيع الملاعب',
  'Match history and basic leaderboard': 'سجل المباريات والترتيب الأساسي',
  'Basic admin dashboard': 'لوحة تحكم أساسية للمدير',
  'Everything in Starter': 'كل ما في ستارتر',
  'Up to 150 active members': 'حتى 150 عضوًا نشطًا',
  'Coach evaluations': 'تقييمات المدربين',
  'Equipment tracking': 'تتبع المعدات',
  'Limited ML-assisted analytics for key performance trends': 'تحليلات محدودة بمساعدة ML للاتجاهات الرئيسية',
  'Actionable performance insights on your dashboard to help members improve faster.': 'رؤى أداء عملية على لوحة التحكم لمساعدة الأعضاء على التحسن بشكل أسرع.',
  'Daily match reports and advanced leaderboard trends': 'تقارير يومية للمباريات واتجاهات متقدمة للترتيب',
  'Everything in Pro': 'كل ما في برو',
  'Up to 250 active members': 'حتى 250 عضوًا نشطًا',
  'Advanced roles and permissions, including multiple club admins': 'أدوار وصلاحيات متقدمة، بما في ذلك تعدد مديري النادي.',
  "Advanced UI controls to customize your app's colors and fonts for your club brand.": 'عناصر تحكم متقدمة في الواجهة لتخصيص ألوان التطبيق وخطوطه بما يناسب هوية ناديك.',
  'Upload and manage your club logo for branded club pages.': 'ارفع شعار ناديك وأدره لعرض صفحات النادي بهوية مميزة.',
  'Members can choose profile avatars for a more personalized experience.': 'يمكن للأعضاء اختيار صور شخصية لتجربة أكثر تخصيصًا.',
  'Chat with AI to uncover hidden patterns and insights from your match history': 'تحاور مع الذكاء الاصطناعي لاكتشاف الأنماط الخفية والرؤى من سجل مبارياتك.',
  'Subscribe yearly Plan': 'اشترك في الخطة السنوية',
  'Yearly plans also include a 14-day free trial. Cancel anytime before trial ends.': 'الخطط السنوية تشمل أيضًا تجربة مجانية لمدة 14 يومًا. يمكنك الإلغاء في أي وقت قبل انتهاء التجربة.',
  'Monthly total:': 'الإجمالي الشهري:',
  'Back': 'رجوع',
  'Create account': 'إنشاء الحساب',
  'Welcome back!': 'مرحبًا بعودتك!',
  'OTP resent to your email.': 'تمت إعادة إرسال OTP إلى بريدك الإلكتروني.',
  'Email verified. Click Continue to proceed.': 'تم التحقق من البريد الإلكتروني. اضغط متابعة للمتابعة.',
  'Account created. Please log in to continue.': 'تم إنشاء الحساب. يرجى تسجيل الدخول للمتابعة.',
  'Failed to load billing snapshot': 'فشل تحميل لقطة الفوترة',
  'Failed to load policies': 'فشل تحميل السياسات',
  'Failed to load failed payments': 'فشل تحميل المدفوعات الفاشلة',
  'Policy title is required': 'عنوان السياسة مطلوب',
  'Draft saved': 'تم حفظ المسودة',
  'Could not save draft': 'تعذر حفظ المسودة',
  'Version is required': 'الإصدار مطلوب',
  'Policy published': 'تم نشر السياسة',
  'Could not publish policy': 'تعذر نشر السياسة',
  'Account created, but billing checkout could not be started.':
    'تم إنشاء الحساب، لكن تعذر بدء الدفع.',
  'Enter your email to receive a reset link': 'أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين',
  'If the email exists, a reset link has been sent':
    'إذا كان البريد الإلكتروني موجودًا، فقد تم إرسال رابط إعادة التعيين',
  'Could not send reset link': 'تعذر إرسال رابط إعادة التعيين',
  'Players assigned to court': 'تم تعيين اللاعبين إلى الملعب',
  'Queue is at capacity for this club': 'قائمة الانتظار ممتلئة لهذا النادي',
  'Players can only add themselves to the queue':
    'يمكن للاعبين فقط إضافة أنفسهم إلى قائمة الانتظار',
  'Players can only remove themselves from the queue':
    'يمكن للاعبين فقط إزالة أنفسهم من قائمة الانتظار',
  'Failed to remove player from court': 'فشل إزالة اللاعب من الملعب',
  'Court IDs are not available yet. Please refresh or update courts in Club Settings.':
    'معرفات الملاعب غير متاحة بعد. يرجى التحديث أو تعديل الملاعب من إعدادات النادي.',
  'Finish the current match on this court before assigning new players':
    'أنهِ المباراة الحالية على هذا الملعب قبل تعيين لاعبين جدد',
  'Need at least 4 players in queue': 'تحتاج إلى 4 لاعبين على الأقل في قائمة الانتظار',
  'Already assigning players to this court...': 'جارٍ بالفعل تعيين اللاعبين إلى هذا الملعب...',
  'Players assigned to court!': 'تم تعيين اللاعبين إلى الملعب!',
  'Players swapped': 'تم تبديل اللاعبين',
  'Queue cleared': 'تم مسح قائمة الانتظار',
  'Queue shuffle is disabled for this club': 'خلط قائمة الانتظار معطل لهذا النادي',
  'Queue shuffled': 'تم خلط قائمة الانتظار',
  'Top player skipped': 'تم تخطي اللاعب الأول',
  'Only players on this court or coaches/admins can finish the match':
    'فقط اللاعبون الموجودون في هذا الملعب أو المدربون/المديرون يمكنهم إنهاء المباراة',
  'You are not allowed to finish this match': 'غير مسموح لك بإنهاء هذه المباراة',
  'Match finished and queue updated': 'تم إنهاء المباراة وتحديث قائمة الانتظار',
  'Profile updated!': 'تم تحديث الملف الشخصي!',
  'Failed to update profile': 'فشل تحديث الملف الشخصي',
  'Avatar feature is available on Elite (Package 3) only.':
    'ميزة الصورة الشخصية متاحة فقط في إيليت (الباقة 3).',
  'Avatar metadata not found': 'لم يتم العثور على بيانات الصورة الشخصية',
  'Avatar saved!': 'تم حفظ الصورة الشخصية!',
  'Failed to save avatar': 'فشل حفظ الصورة الشخصية',
  'Select a club first.': 'اختر ناديًا أولاً.',
  'Select a club first': 'اختر ناديًا أولاً',
  'Selected role is not available in this package.':
    'الدور المحدد غير متاح في هذه الباقة.',
  'Failed to import CSV file': 'فشل استيراد ملف CSV',
  'Please fill in required fields': 'يرجى تعبئة الحقول المطلوبة',
  'Member added successfully!': 'تمت إضافة العضو بنجاح!',
  'Failed to add member': 'فشل إضافة العضو',
  'Member updated!': 'تم تحديث العضو!',
  'Failed to update member': 'فشل تحديث العضو',
  'Member removed': 'تمت إزالة العضو',
  'Cannot delete member while they are queued or playing':
    'لا يمكن حذف العضو أثناء وجوده في قائمة الانتظار أو أثناء اللعب',
  'Coach role is not available in this package.': 'دور المدرب غير متاح في هذه الباقة.',
  'Select at least one member to import.': 'اختر عضوًا واحدًا على الأقل للاستيراد.',
  'Selected rows must include first name, last name, and email.':
    'يجب أن تتضمن الصفوف المحددة الاسم الأول واسم العائلة والبريد الإلكتروني.',
  'Active members updated to match your package limit.':
    'تم تحديث الأعضاء النشطين ليتوافقوا مع حد باقتك.',
  'Failed to apply member limit selection': 'فشل تطبيق اختيار حد الأعضاء',
  'Match finished': 'تم إنهاء المباراة',
  'Evaluation updated!': 'تم تحديث التقييم!',
  'Evaluation added!': 'تمت إضافة التقييم!',
  'Failed to save evaluation': 'فشل حفظ التقييم',
  'Evaluation deleted': 'تم حذف التقييم',
  'Failed to delete evaluation': 'فشل حذف التقييم',
  'Equipment added!': 'تمت إضافة المعدات!',
  'Failed to add equipment': 'فشل إضافة المعدات',
  'Equipment updated!': 'تم تحديث المعدات!',
  'Failed to update equipment': 'فشل تحديث المعدات',
  'Equipment deleted': 'تم حذف المعدات',
  'Failed to delete equipment': 'فشل حذف المعدات',
  'Failed to load goals': 'فشل تحميل الأهداف',
  'Evaluations refreshed': 'تم تحديث التقييمات',
  'Failed to refresh evaluations': 'فشل تحديث التقييمات',
  'Goal updated': 'تم تحديث الهدف',
  'Could not update goal': 'تعذر تحديث الهدف',
  'Failed to delete': 'فشل الحذف',
  'Club logo is available on Elite (Package 3). Please upgrade your package.':
    'شعار النادي متاح في إيليت (الباقة 3). يرجى ترقية باقتك.',
  'Logo file is too large (max 2MB)': 'ملف الشعار كبير جدًا (الحد الأقصى 2MB)',
  'Logo uploaded': 'تم رفع الشعار',
  'Failed to upload logo': 'فشل رفع الشعار',
  'Please fill in all play time fields': 'يرجى تعبئة جميع حقول أوقات اللعب',
  'Club name is required': 'اسم النادي مطلوب',
  'Sport type is required': 'نوع الرياضة مطلوب',
  'Add at least one scheduled play time': 'أضف وقت لعب مجدول واحدًا على الأقل',
  'You do not have permission to update the club': 'ليس لديك صلاحية تحديث النادي',
  'Club updated successfully!': 'تم تحديث النادي بنجاح!',
  'Club created successfully!': 'تم إنشاء النادي بنجاح!',
  'Could not start checkout': 'تعذر بدء الدفع',
  'Could not open billing portal': 'تعذر فتح بوابة الفوترة',
  'Subscription cancellation scheduled for period end.':
    'تمت جدولة إلغاء الاشتراك لنهاية الفترة.',
  'Could not cancel subscription': 'تعذر إلغاء الاشتراك',
  'No active club selected': 'لم يتم تحديد نادٍ نشط',
  'Club updated': 'تم تحديث النادي',
  'Could not update club': 'تعذر تحديث النادي',
  'You were logged out due to inactivity.': 'تم تسجيل خروجك بسبب عدم النشاط.',
  'Your weekly insight is ready.': 'رؤيتك الأسبوعية جاهزة.',
  'Unable to generate an insight right now.': 'يتعذر إنشاء رؤية في الوقت الحالي.',
  'These email(s) are already exist. Remove those from selection, then continue import.':
    'هذه الرسائل الإلكترونية موجودة بالفعل. أزلها من التحديد ثم تابع الاستيراد.',
  'These email(s) are already exist.': 'هذه الرسائل الإلكترونية موجودة بالفعل.',
  'Remove those from selection, then continue import.':
    'أزلها من التحديد ثم تابع الاستيراد.',
  'We sent a reset link to': 'لقد ارسلنا رابطا لاعادة التعيين إلى',
  'The link expires shortly, so use it soon.':
    'سينتهي الرابط قريبا، لذا استخدمه بسرعة.',
  'Cannot deactivate while member is queued or playing':
    'لا يمكن إلغاء تفعيل العضو أثناء وجوده في قائمة الانتظار أو أثناء اللعب',
  'Cannot deactivate while عضو is queued or playing':
    'لا يمكن إلغاء تفعيل العضو أثناء وجوده في قائمة الانتظار أو أثناء اللعب',
  'match already finished': 'تم إنهاء المباراة بالفعل',
  'player': 'لاعب',
  'players': 'لاعبون',
  'Player': 'لاعب',
  'Players': 'لاعبون',
  'coach': 'مدرب',
  'coaches': 'مدربون',
  'Coach': 'مدرب',
  'Coaches': 'مدربون',
  'admin': 'مدير',
  'admins': 'مديرون',
  'Admin': 'مدير',
  'Admins': 'مديرون',
  'Nickname': 'الاسم المستعار',
  'Update member information.': 'تحديث معلومات العضو.',
  'Update عضو information.': 'تحديث معلومات العضو.',
  'Active': 'نشط',
  'active': 'نشط',
  'Inactive': 'غير نشط',
  'Member activated': 'تم تفعيل العضو',
  'Member deactivated': 'تم إلغاء تفعيل العضو',
  'Delete this evaluation? This cannot be undone.':
    'هل تريد حذف هذا التقييم؟ لا يمكن التراجع عن هذا الإجراء.',
  'Are you sure you want to delete this equipment?':
    'هل أنت متأكد أنك تريد حذف هذه المعدات؟',
  'Edit Equipment': 'تعديل المعدات',
  'Type': 'النوع',
  'Shoes': 'أحذية',
  'Racket': 'مضرب',
  'Manufacturer *': 'الشركة المصنعة *',
  'Make/Model *': 'العلامة/الموديل *',
};

export default arRuntimeTranslations;
